<button on:click type="button" class="button">
    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
</button>